const handleContactDisplay = () => {
    const contactCard = document.querySelector('.property-for-sale-contact:not(.fixed)');
    const contactFixed = document.querySelector('.property-for-sale-contact.fixed');
    const contactCardPos = contactCard.getBoundingClientRect();

    window.addEventListener('scroll', () => {
        const currentScrollY = document.documentElement.scrollTop;

        if (currentScrollY > contactCardPos.bottom) {
            contactFixed.style.display = 'block';
        } else {
            contactFixed.style.display = 'none';
        }
    });
};

document.addEventListener('DOMContentLoaded', () => {
    // check if this page actually has property hero banner:
    const propertyHeroBanner = document.querySelector('.property-hero-banner-block');
    if (!propertyHeroBanner) {
        return;
    }

    handleContactDisplay();
});
